export default [
  {
    path: "/campaign",
    name: "Campaign",
    component: () => import("@/modules/gmailExtension/pages/Campaign.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Campaign",
      breadcrumb: [
        {
          text: "Campaign",
          active: true,
        },
      ],
    },
  },
  {
    path: "/campaign-mail-status/:campaignId/:isMultiple?",
    name: "CampaignMailStatus",
    component: () => import("@/modules/gmailExtension/pages/CampaignMailStatus.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Campaign Mail Status",
      breadcrumb: [
        {
          text: "Campaign",
          active: false,
          to: '/campaign',
        },{
          text: "Campaign Mail Status",
          active: true,
        }
      ],
    },
  },
];
